import { checkHashStore } from '../../../store/checkHashStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { TranslationKeys } from '../../../core/constants/translationKeys';
import {
  CombinationTypes,
  INCLUDED_SPINS,
  marketType,
  ROUlETTE_NUMBERS_BY_INDEX,
} from '../rouletteCore/constants';
import { rouletteBetsStore } from '../rouletteStore/betStore';
import { autoBetStore } from '../../../store/autoBetStore';
import { rouletteWheelStore } from '../rouletteStore/rouletteWheelStore';
import { getCurrentRotation } from '../rouletteCore/helpers/getCurrentRotation';
import { soundService } from '../../../services/baseSoundService/soundService';
import { RouletteSoundsName } from '../rouletteCore/constants/sounds';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { ValidationType } from '../../../core/constants/validationType';
import { notificationStore } from '../../../store/notificationStore';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { freeBetStore } from '../../../store/freeBetStore';

let autoBetTimeOutId = null;

class RouletteGameService {
  onGetInitialStateResult({ lastSpinInfo }) {
    this.handleResetInitial();
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo({
        key: lastSpinInfo.key,
        salt: lastSpinInfo.salt,
        hash: lastSpinInfo.hash,
      });
      checkHashStore.setLastRoundResult({
        id: lastSpinInfo.id,
        date: lastSpinInfo.date,
        markets: lastSpinInfo.markets,
        resultNumber: lastSpinInfo.number,
      });
    }
    checkHashStore.setNextHashTextInfo(TranslationKeys.NextRound);
  }

  doSpin() {
    const { allBetsModels } = rouletteBetsStore;
    if (allBetsModels.length) {
      rouletteBetsStore.setResultNumberForTable(null);
      if (autoBetStore.isAutoBetOn && !autoBetStore.isAutoBetStart) {
        autoBetStore.setIsAutoBetStart(true);
      }
      if (!rouletteBetsStore.isBetsClosed) {
        soundService.play(RouletteSoundsName.bet);
        const spinData = allBetsModels[0].betModel.reduce((acc, cur) => {
          if (INCLUDED_SPINS.includes(cur.bet.type)) {
            acc.push({
              spin: {
                type: cur.bet.type,
              },
              includedSpins: CombinationTypes[cur.bet.type].map((item) => {
                if (cur.bet.type === marketType.Voisins) {
                  const amount =
                    item === marketType.Street_0_2_3 || item === marketType.Corner_25_26_28_29
                      ? (cur.bet.amount / CombinationTypes[cur.bet.type].length + 2) * 2
                      : cur.bet.amount / CombinationTypes[cur.bet.type].length + 2;

                  return {
                    type: item,
                    amount: amount,
                  };
                }

                return {
                  type: item,
                  amount: cur.bet.amount / CombinationTypes[cur.bet.type].length,
                };
              }),
            });
          } else {
            acc.push({ spin: cur.bet });
          }
          return acc;
        }, []);
        mainGameConnection.doSpin(
          {
            spinData,
            isAutoplay: autoBetStore.isAutoBetOn,
            isTurbo: userSettingsStore.isTurboOn,
          },
          false
        );
        const elem = document.getElementById('roulette-wheel');
        rouletteWheelStore.setStartPosition(Math.round(getCurrentRotation(elem)));
        rouletteBetsStore.setIsBetsClosed(true);
      }
    }
  }

  handleDoSpinResult({ winAmount, hash, newHash, key, salt, id, responseCode, odd, result }) {
    if (responseCode === ValidationType.Success) {
      const { resultNumber } = result;
      userInfoStore.getBalance();
      const elem = document.getElementById('roulette-wheel');
      rouletteWheelStore.setWheelCurrentIndex(Math.round(getCurrentRotation(elem)));
      const { currentFreeBet } = freeBetStore;
      const { isTurboOn } = userSettingsStore;
      if (
        currentFreeBet &&
        rouletteBetsStore.allBetsModels.length > currentFreeBet.remainingCount
      ) {
        if (autoBetStore.isAutoBetStart) {
          autoBetStore.setIsAutoBetStart(false);
        }
        rouletteBetsStore.allBetsModels = [];
      }
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.setAutoBetCount(autoBetStore.autoBetCount - 1);
        if (autoBetStore.autoBetCount < 1) {
          this.resetAutoBetState();
        }
      }

      setTimeout(() => {
        checkHashStore.setLastRoundInfo({ salt, key, hash });
        checkHashStore.setNextRoundHash(newHash);
        checkHashStore.setLastRoundResult({
          resultNumber,
          id,
        });
      }, 500);
      if (!isTurboOn) {
        soundService.play(RouletteSoundsName.wheel, true);
      }
      rouletteWheelStore.startWheel(ROUlETTE_NUMBERS_BY_INDEX[resultNumber].index);

      this.wheelRotateTieOut = setTimeout(
        () => {
          setTimeout(
            () => {
              if (winAmount) {
                soundService.play(RouletteSoundsName.win);
              }
              rouletteWheelStore.endWheel(ROUlETTE_NUMBERS_BY_INDEX[resultNumber].index);
              rouletteBetsStore.updateLastResults({ isWin: Boolean(winAmount), resultNumber });
              rouletteBetsStore.setResult({
                resultNumber,
                isWin: Boolean(winAmount),
                odd,
                winAmount: winAmount,
              });
              setTimeout(
                () => {
                  rouletteBetsStore.setIsBetsClosed(false);
                  setTimeout(() => {
                    rouletteBetsStore.setResult(null);
                  }, 500);
                  rouletteWheelStore.resetBetStore();
                  setTimeout(() => {
                    userInfoStore.getBalance();
                    betHistoryStore.getLastBet();
                  }, 500);
                  if (autoBetStore.isAutoBetStart && autoBetStore.autoBetCount) {
                    autoBetTimeOutId = setTimeout(
                      () => {
                        this.doSpin();
                      },
                      isTurboOn ? 250 : 400
                    );
                  }
                  rouletteBetsStore.setIsSecondClick(false);
                },
                isTurboOn ? 300 : 700
              );
              if (!isTurboOn && !autoBetStore.isAutoBetStart) {
                rouletteBetsStore.setIsSecondClick(true);
              }
            },
            isTurboOn ? 200 : 400
          );
          rouletteBetsStore.setResultNumberForTable(resultNumber);
        },
        isTurboOn ? 1000 : 1500
      );
    } else {
      autoBetStore.resetAutoBetState();
      notificationStore.setNotification(responseCode);
      rouletteBetsStore.setIsBetsClosed(false);
    }
  }

  handleSecondClick() {
    if (!rouletteBetsStore.result) return;
    const { resultNumber, isWin } = rouletteBetsStore.result;
    clearTimeout(this.wheelRotateTieOut);
    rouletteBetsStore.setIsSecondClick(true);
    rouletteWheelStore.startWheel(ROUlETTE_NUMBERS_BY_INDEX[resultNumber].index);
    rouletteBetsStore.setResultNumberForTable(resultNumber);
    if (isWin) {
      soundService.play(RouletteSoundsName.win);
    }
    rouletteBetsStore.updateLastResults({ isWin, resultNumber });
    setTimeout(() => {
      setTimeout(() => {
        userInfoStore.getBalance();
        betHistoryStore.getLastBet();
      }, 4000);
      rouletteWheelStore.endWheel(ROUlETTE_NUMBERS_BY_INDEX[resultNumber].index);
      setTimeout(() => {
        rouletteBetsStore.setIsBetsClosed(false);
        rouletteWheelStore.resetBetStore();
        rouletteBetsStore.setIsSecondClick(false);
      }, 400);
      rouletteBetsStore.setResult(null);
    }, 400);
  }

  resetAutoBetState() {
    if (autoBetStore.isAutoBetStart && autoBetStore.isAutoBetOn && !autoBetStore.autoBetCount) {
      setTimeout(() => {
        autoBetStore.resetAutoBetState();
        this.clearAutoBetTimeOut();
      }, 500);
    }
  }

  clearAutoBetTimeOut() {
    return clearTimeout(autoBetTimeOutId);
  }

  handleResetInitial() {
    this.resetAutoBetState();
    rouletteWheelStore.resetBetStore();
    rouletteBetsStore.setIsBetsClosed(false);
  }
}

export const rouletteGameService = new RouletteGameService();
